import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { CustomeDialog, CustomTable } from "../../../shared";
import { useEndofDayHistory } from "../hooks/useEndofDayHistory";
import { Button, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";


export const EndofDayHistory = () => {
  const { id } = useParams();
  const { state, handleModal } = useEndofDayHistory({ id });

  const { dataList, isLoading, selectedData, isModalOpen } = state;


  const ActionButtons = ({ data }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Button
          variant="outlined"
          sx={{ border: "none", ":hover": { border: "none" } }}
          size="small"
          onClick={() => handleModal(true, data)}
        >
          View Changes
        </Button>
      </div>
    );
  };

  const column = React.useMemo(
    () => [
      {
        Header: "Date & Time",
        accessor: "done_on",
      },
      {
        Header: "User",
        accessor: (row) => row.done_by_name ? row.done_by_name : "System"
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons data={row} />;
        },
      },
    ],
    []
  );


  const ChangesTable = () => {
    return (
      <>
        <Stack padding="12px">
          <Stack>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Keys</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>New Value</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Old Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedData && selectedData.length > 0 ? (
                  selectedData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.keys}</TableCell>
                      <TableCell>{item.new}</TableCell>
                      <TableCell>{item.old}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>No changes found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Stack>
        </Stack>
      </>
    )
  }

  return (
    <>
      <CustomTable
        columns={column}
        data={dataList}
        isLoading={isLoading}
        tableTitle="History"
        defaultSearch={false}
        searchBar={false}
      />
      <CustomeDialog
        title={<Typography variant="h6" sx={{ padding: "10px 20px" }}>
          Changes
        </Typography>}
        PaperProps={{
          sx: {
            minWidth: "579px",
            minHeight: "297px",
          },
        }}
        open={isModalOpen}
        handleClose={() => handleModal(false)}
        content={
          <ChangesTable />
        }
      />
    </>
  );
};
